import { render, staticRenderFns } from "./ManterDRE.vue?vue&type=template&id=4c8c9716&scoped=true&"
import script from "./ManterDRE.vue?vue&type=script&lang=js&"
export * from "./ManterDRE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8c9716",
  null
  
)

export default component.exports